<template>
  <div>
    <Button variant="outline" size="lg" @click="showMessageTeam = true">
      Message Team
      <vue-feather type="message-circle" size="20" />
    </Button>
  </div>

  <TeamMessage
    v-if="showMessageTeam"
    @handle-message-team="showMessageTeam = false"
    @handle-message-team-cancel="showMessageTeam = false"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TeamMessage from './TeamMessage.vue';
import { Button } from '@/components/ui/button';

const showMessageTeam = ref(false);
</script>
